import { UiBox, UiSpinner, UiTypography } from "@smp/ui";
import clsx from "clsx";
import { forwardRef } from "react";

import { ButtonBack } from "./components/button_back";
import classes from "./screen.module.css";
import { IScreenProps } from "./screen.types";

export const Screen = forwardRef<HTMLDivElement, IScreenProps>(
  (
    {
      actionsLeft,
      actionsRight,
      back,
      children,
      isLoading = false,
      title,
      titleLineNum = 3,
      contentRef,
      BoxProps,
      ContentBoxProps,
      HeadBoxProps,
    },
    ref,
  ) => (
    <UiBox
      display="flex"
      flexDirection="column"
      maxHeight="100%"
      {...BoxProps}
      className={BoxProps?.className}
      ref={ref}
    >
      {(title || back || actionsLeft || actionsRight) && (
        <UiBox
          {...HeadBoxProps}
          className={clsx(classes.head, HeadBoxProps?.className)}
        >
          <div className={classes.head__left}>
            {(title || back) && (
              <div className={classes.head__left__main}>
                {back ? (
                  <div className={classes.head__left__back}>
                    <ButtonBack to={back} />
                  </div>
                ) : undefined}

                {title && (
                  <UiTypography
                    component="div"
                    className={classes.head__left__title}
                    variant="h3"
                    sx={{
                      lineClamp: titleLineNum,
                      WebkitLineClamp: titleLineNum,
                      maxHeight: `calc(1.2em * ${titleLineNum})`,
                    }}
                  >
                    {title}
                  </UiTypography>
                )}
              </div>
            )}

            {actionsLeft && (
              <UiBox className={classes.head__left__actions} flexGrow={0}>
                {actionsLeft}
              </UiBox>
            )}

            {isLoading && <UiSpinner className={classes.spinner} size={20} />}
          </div>

          {actionsRight && (
            <div className={classes.head__right}>{actionsRight}</div>
          )}
        </UiBox>
      )}
      <UiBox
        ref={contentRef}
        {...ContentBoxProps}
        className={clsx(
          classes.content,
          (actionsLeft || actionsRight || title) && classes.content_with_head,
          ContentBoxProps?.className,
        )}
      >
        {children}
      </UiBox>
    </UiBox>
  ),
);
